import { createContext, useContext, useState } from 'react';

type ContextValue = {
  isNavOpen: boolean;
  openNav: () => void;
  closeNav: () => void;
};

const LayoutContext = createContext<ContextValue | undefined>(undefined);

type Props = {
  children: React.ReactNode;
};
export const LayoutProvider = ({ children }: Props) => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const openNav = () => {
    setIsNavOpen(true);
  };

  const closeNav = () => {
    setIsNavOpen(false);
  };

  const value = { isNavOpen, openNav, closeNav };

  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};
